import {
  RelatedContent as V3RelatedContent,
  RelatedContentProps,
} from '@stadionhq-v3/base-ui';
import classnames from 'classnames';
import styles from './relatedContent.module.scss';

const RelatedContent = ({
  classNames,
  onDark,
  ...props
}: RelatedContentProps) => {
  const classes = classnames(
    [
      styles.tokens,
      styles.relatedContent,
      {
        [`${styles.onDark}`]: onDark,
      },
    ],
    classNames
  );

  return <V3RelatedContent classNames={[classes]} onDark={onDark} {...props} />;
};

export default RelatedContent;
